<template>
  <div class="footer">
    <a
      class="deputy-link google_play_btn"
      href="https://play.google.com/store/apps/details?id=com.deputy.android"
      target="_blank"
    >
      <div class="deputy-text">
        <img src="images/deputy-logo.svg" />
        <p>Manage your shifts with ease.</p>
      </div>
      <img src="images/google-play.svg" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'PlayStoreButton',
  props: {},
  data() {
    return {};
  },
};
</script>

<style>
.footer {
  display: flex;
  justify-content: center;
  padding: 1rem;
}

.deputy-link {
  display: flex;
  width: 100%;
  justify-content: center;
}
.deputy-link > div {
  width: 15rem;
  padding-right: 1rem;
  padding-left: 0;
  text-align: left;
}

.deputy-link > div > img {
  width: 10rem;
}
.deputy-link > div > p {
  margin: 0;
  padding-top: 1rem;
  font-weight: 500;
}

.deputy-text {
  padding: 1rem;
  font-size: xx-small;
  color: #4b6d7f;
}

.google_play_btn {
  display: flex;
  justify-content: space-evenly;
  text-decoration: none;
  border-radius: 5px;
  padding: 0.5rem;
  margin: 1rem;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  font-weight: bold;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.66);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.28);
}

.google_play_btn:active {
  -ms-transform: translateY(2px);
  -webkit-transform: translateY(2px);
  transform: translateY(2px);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.15);
  background-image: -webkit-linear-gradient(#fed6e3 0%, #ffbcbc 100%);
  background-image: linear-gradient(#fed6e3 0%, #ffbcbc 100%);
}
</style>
